import { createAction } from '@reduxjs/toolkit'
import { BulkNoteRequest, BulkNoteResponse, NoteRequest, NoteResponse } from '../api'

export const sendComment = createAction<NoteRequest>('COMMENT_SEND')
export const sentComment = createAction<NoteResponse>('COMMENT_SENT')
export const requestBulk = createAction<BulkNoteRequest>('COMMENTS_REQUEST')
export const receivedBulk = createAction<BulkNoteResponse>('COMMENTS_RECEIVED')
